import React from "react";
import ReactDOM from "react-dom/client";
import RifaApp from "./rifa-app";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RifaApp />
  </React.StrictMode>,
);
